import { MIN_ENROLLMENT_COUNT_FOR_DISPLAY } from "../../CourseRunSelector/constants";
import { ProcessedCourse } from "@/common/course/types";
import MidPageCTAEnrollment from "./MidPageCTAEnrollment";
// redesign
import { getCourseRunStartText } from "@/lib/course/utils/getCourseRunTilePrimaryText";
import useCourseEnrollment from "../CourseEnroll/hooks/useCourseEnrollment";
import { getCourseRunEndText } from "@/lib/course/utils/getCourseRunTitleSecondaryText";
import getNextCourseOneLineText from "../CourseEnroll/utils/getNextCourseOneLineText";
import useTranslations from "@/i18n/useTranslations";

export interface Props {
  course: ProcessedCourse;
  isArchived?: boolean;
}

export default function MidPageCTA({ course, isArchived }: Props) {
  const t = useTranslations("Course");
  const translate =
    t as unknown as import("@/lib/course/utils/getCourseInformation").CourseInfoTranslate;
  const { enrollmentCount, activeCourseRun } = course || {};
  const { isCourseArchived, isCourseEnrollable } = useCourseEnrollment({
    courseRun: activeCourseRun!,
    course,
  });
  if (!course || !course.activeCourseRun) return;
  const endText = getCourseRunEndText(course.activeCourseRun, translate);
  const showEnrollmentCount =
    !isArchived &&
    activeCourseRun?.isEnrollable &&
    enrollmentCount &&
    enrollmentCount >= MIN_ENROLLMENT_COUNT_FOR_DISPLAY;

  const multipleRunsAvailable = (course.activeCourseRuns || []).length > 1;

  let seeMoreDatesHandler = false;
  if (multipleRunsAvailable) {
    seeMoreDatesHandler = true;
  }

  const startText = getCourseRunStartText(
    course.activeCourseRun,
    !!seeMoreDatesHandler,
    translate,
  );

  if (!course || !course.activeCourseRun) return;

  return (
    <div className="flex flex-col text-center gap-4 py-4 md:py-0 border md:border-none rounded-xl md:rounded-none">
      {isCourseArchived || !isCourseEnrollable ? (
        <span className="font-bold text-base">{t("thisCourseIsArchived")}</span>
      ) : (
        <div className="text-center">
          <h2
            className="text-base md:text-3xl font-bold my-0"
            data-testid="course-heading"
          >
            {getNextCourseOneLineText(startText, translate)}
          </h2>
          {endText && <div className="text-sm">{endText}</div>}
        </div>
      )}

      {showEnrollmentCount ? (
        <div className="text-md md:text-lg text-gray-800">
          <span className="font-bold">{enrollmentCount.toLocaleString()}</span>
          <span>&nbsp;{t("learnersEnrolled")}</span>
        </div>
      ) : null}
      <div className="self-center">
        <MidPageCTAEnrollment course={course} />
      </div>
    </div>
  );
}
